import { render } from "./RegistersTable.vue?vue&type=template&id=40d7bc28&ts=true"
import script from "./RegistersTable.vue?vue&type=script&lang=ts"
export * from "./RegistersTable.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/javiermartin/OneDrive_Sigeen/Sistena/Server_Mio/sistena-admin-gui-main_rev1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__